
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class SwitchWithConfirm extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop(Boolean) readonly readonly!: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Boolean, default: false }) readonly noConfirm!: boolean;
  @Prop(Array) readonly rules!: (string | boolean)[];
  @Prop(String) readonly successText!: string;
  @Prop(String) readonly errorText!: string;
  @Prop(String) readonly turnOnTitle!: string;
  @Prop(String) readonly turnOffTitle!: string;
  @Prop({ type: Boolean, default: false }) readonly persistentHint!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideDetails!: boolean;
  @Prop(String) readonly hint!: string;
  @Prop({ type: String, default: 'success' }) readonly color!: string;
  @Prop(String) readonly successIcon?: string;
  @Prop(String) readonly errorIcon?: string;

  // switchValue = false
  confirmDialog = false

  // @Watch('value')
  // onValueChange(val: boolean) {
  //   console.log('SwitchWithConfirm: onValueChange()'); // eslint-disable-line no-console

  //   this.switchValue = val;
  // }

  // @Watch('switchValue')
  // onSwitchValueChange(val: boolean) {
  //   if (this.value !== val) {
  //     this.$emit('input', val);
  //   }
  // }

  ignoreClick(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  onClick() {
    if (!this.readonly && !this.disabled) {
      console.log('SwitchWithConfirm: onClick()'); // eslint-disable-line no-console
      if (this.noConfirm) {
        this.onConfirm();
      } else {
        this.confirmDialog = true;
      }
    }
  }

  onConfirm() {
    this.confirmDialog = false;
    setTimeout(() => {
      this.$emit('input', !this.value);
      this.$emit('change');
    }, 500);
  }
}
